import axios from "axios";
import { calculateHours } from "./flyhourService";

const API_URL =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/api/emissions` // For airport mode
    : process.env.REACT_APP_API_URL || "http://localhost:5000/api/emissions";

export const fetchCalculationByEmissionId = async (emissionId) => {
  const response = await axios.get(
    `${API_URL}/calculate-emissions?emissionId=${emissionId}`
  );
  return response.data;
};

export const calculateEmissions = async (payload) => {
  try {
    // Check mode, default to "airport"
    const mode = payload.mode || "airport";

    if (mode === "hours") {
      // Delegate flying-hours calculation to flyhourService
      return await calculateHours(payload);
    } else {
      // Airport calculation - POST to /api/emissions/calculate-emissions
      const response = await axios.post(`${API_URL}/calculate-emissions`, {
        origin: payload.departure,
        destination: payload.arrival,
        passengers: payload.passengers,
        cabinClass: payload.cabinClass,
        tripType: payload.tripType,
        operatingCarrierCode: payload.operatingCarrierCode,
        flightNumber: payload.flightNumber,
        departureDate: payload.departureDate,
        email: payload.email,
        emissionId: payload.emissionId,
        isTermsAccepted: payload.isTermsAccepted,
      });
      return { success: true, data: response.data };
    }
  } catch (error) {
    console.error(
      "API Error:",
      error.response?.data?.error,
      error.response?.status
    );
    const status = error.response?.status;
    if (status === 400) {
      return { success: false, error: error.response?.data?.error };
    }
    return { success: false, error: "Failed to calculate emissions." };
  }
};
